export default __webpack_public_path__ + "static/media/comfortable.b0a1c7d3.png";